import propTypes from "prop-types";
import navigation from "../components/Navigation";
import bars from "../assets/bars.svg";
import Button from "./Button";

// this is a simple header, getting title string from parent
// long title, short title will set on render once.
const Header = (props) => {
  
  
  let isLoggedIn = sessionStorage.getItem("isLoggedIn");

  function defaultLogOutButton(e) {
    if (props.buttonAction === undefined || props.buttonAction === null) {
      // assign to default RHSSO for all logout

    } else {
      // if using a custom logout

      props.buttonAction(e);
    }
  }


	function checkLogin() {
	    let loggedIn = true;
	    if ((isLoggedIn === undefined) || 
	    	(isLoggedIn === false) || 
	    	(isLoggedIn === "false") ||
	    	(isLoggedIn === null )) {
	      loggedIn = false;
	    } 
	    
	     return loggedIn;
  }

//only show the mobile hamburgerMenu if user is logged in or has menu item(s)
 const hasShowInMenuTrue = navigation.some(item => item.showInMenu === true); 
 const showMobileMenu = checkLogin() ||  hasShowInMenuTrue;
	  
const mobileMenuIcon =  showMobileMenu ? <img src={bars} alt="Open Menu" id="openMenuIcon" className="" onMouseUp={props.handleMouseUp}/> : "";
  return (
	<header className="header">
	    {mobileMenuIcon}
    	{/*<img src={bars} alt="Open Menu" id="openMenuIcon" className="" onMouseUp={props.handleMouseUp}/>*/}
	    <div className="header__title">{window.innerWidth > 770 ? props.longTitle : props.shortTitle}</div>
      	<div className="header__user" style={window.innerWidth > 770 ? {} : { display: "hidden" }}>
        <div className="header__user-name">{props.userName}</div>
        <div className={checkLogin()  ? {} : "hide_div" }>
          <Button text={props.buttonLabel} styleName="button button--secondary button--smaller " onClick={defaultLogOutButton} id={"header_components_logout_button"}/>
        </div>
      </div>
      </header>
  );
};

// in case nothing is passed in
Header.defaultProps = {
  longTitle: "NEED TITLE (archetype)",
  shortTitle: "BCH App"
};

// set title type to string, and make it required
Header.propTypes = {
  longTitle: propTypes.string.isRequired,
  shortTitle: propTypes.string.isRequired
};

export default Header;
